module.exports = __webpack_public_path__ + "static/media/LS.2b98f221.png";